document.addEventListener('teeinblue-event-after-cart-added', function() {
  var request = new XMLHttpRequest();
  
  request.open('GET', '/cart.js', true);

  request.onload = function() {
    if (this.status >= 200 && this.status < 400) {
      var data = JSON.parse(this.response);
      var itemCount = data.item_count;
      var cartCount = document.querySelectorAll('.header__cart-count cart-count');
      
      if (cartCount.length) {
        cartCount.forEach(function(cart) {
          cart.style.opacity = 1;
          cart.innerText = itemCount;
        });
      }
    }
  };

  request.send();
});